export default __webpack_public_path__ + "static/media/undraw_education.e7f2326f.svg";